export const TreeDataService = {
  getTreeNodesData() {
    return [
      {
        parentId: "-1",
        childCount: 1,
        id: "fd280e15-60ae-42c1-aaaa-360c226de323",
        name: "21Feb25ACT Root",
        mongoId: 22253,
        type: ["ROOT"],
        hasChildren: true,
        children: [
          {
            parentId: "fd280e15-60ae-42c1-aaaa-360c226de323",
            childCount: 1,
            id: "bc6f2b89-d7ca-4acb-922b-b58092522a45",
            name: "BANGLORE",
            mongoId: 34040,
            type: ["CAMPUS"],
            hasChildren: true,
            children: [
              {
                parentId: "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                childCount: 1,
                id: "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                name: "ABC",
                mongoId: 39225,
                type: ["GROUP"],
                hasChildren: true,
                children: [
                  {
                    parentId: "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                    childCount: 1,
                    id: "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                    name: "Test_Group",
                    mongoId: 37060,
                    type: ["GROUP"],
                    hasChildren: true,
                    children: [
                      {
                        parentId: "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                        childCount: 1,
                        id: "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                        name: "BGL 17",
                        mongoId: 34041,
                        type: ["BUILDING", "NETWORK"],
                        hasChildren: true,
                        children: [
                          {
                            parentId: "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                            childCount: 0,
                            id: "0c22613b-03cd-4898-bb23-19c13765bbfa",
                            name: "Floor 7",
                            mongoId: 39344,
                            type: ["FLOOR"],
                            hasChildren: false,
                            children: null,
                            childData: [],
                            isChildrenLoading: false,
                            nodesBelow: 1,
                            parentTimeZoneId: "Asia/Calcutta",
                            inferredTimeZoneId: "",
                            richMapInfo: {
                              levelName: "Floor 7",
                              pointrLevel: "7",
                              lhLevel: 7,
                            },
                            totalArea: 0,
                            totalAreaUnit: "",
                            totalCapacity: 0,
                            geoLocation: "0.0,0.0",
                            maps: [
                              {
                                name: "0ce58149e01cfeb1ffd1244f28e3736c",
                                source: "SPACES_2D_MAP",
                                zoomLevel: 4,
                                maxDimension: 4096,
                                maxResolution: 16,
                                imagePath:
                                  "mapservices/floor/255afccc8af662895c98741bca9fb9213750b070d1c945061edf6bb6270b6a74/0ce58149e01cfeb1ffd1244f28e3736c",
                                mimeType: "image/png",
                                imageWidth: 4096,
                                imageHeight: 2186,
                                length: 170.6513739130864,
                                width: 319.75664572186724,
                                height: 0,
                                unit: "FEET",
                                offsetX: 0,
                                offsetY: 0,
                                mapCoordinates: [
                                  "7.9,3.9,0.0",
                                  "299.9,166.7,0.0",
                                  "315.9,99.6,0.0",
                                  "7.8,160.8,0.0",
                                ],
                                gpsMarkers: [
                                  "12.93233760999999,77.69571308000002",
                                  "12.933062059999997,77.69628878999998",
                                  "12.933132810000004,77.69610892999998",
                                  "12.932272760000004,77.69614937",
                                ],
                                boundary: [
                                  {
                                    latitude: 12.93311757,
                                    longitude: 77.69619923,
                                  },
                                  {
                                    latitude: 12.93311663,
                                    longitude: 77.69619906,
                                  },
                                  {
                                    latitude: 12.93308106,
                                    longitude: 77.69619349,
                                  },
                                  {
                                    latitude: 12.93308013,
                                    longitude: 77.69619335,
                                  },
                                  {
                                    latitude: 12.93307632,
                                    longitude: 77.69619275,
                                  },
                                  {
                                    latitude: 12.93307619,
                                    longitude: 77.69619374,
                                  },
                                  {
                                    latitude: 12.93306206,
                                    longitude: 77.69628879,
                                  },
                                  {
                                    latitude: 12.93236539,
                                    longitude: 77.69617978,
                                  },
                                  {
                                    latitude: 12.93236528,
                                    longitude: 77.69618047,
                                  },
                                  {
                                    latitude: 12.93227948,
                                    longitude: 77.69616704,
                                  },
                                  {
                                    latitude: 12.93228189,
                                    longitude: 77.6961508,
                                  },
                                  {
                                    latitude: 12.93227276,
                                    longitude: 77.69614937,
                                  },
                                  {
                                    latitude: 12.93229933,
                                    longitude: 77.69597063,
                                  },
                                  {
                                    latitude: 12.93229948,
                                    longitude: 77.69596964,
                                  },
                                  {
                                    latitude: 12.93228877,
                                    longitude: 77.69596797,
                                  },
                                  {
                                    latitude: 12.93228932,
                                    longitude: 77.69596431,
                                  },
                                  {
                                    latitude: 12.93229938,
                                    longitude: 77.69589662,
                                  },
                                  {
                                    latitude: 12.93229992,
                                    longitude: 77.69589297,
                                  },
                                  {
                                    latitude: 12.93231063,
                                    longitude: 77.69589464,
                                  },
                                  {
                                    latitude: 12.93231077,
                                    longitude: 77.69589366,
                                  },
                                  {
                                    latitude: 12.93233761,
                                    longitude: 77.69571308,
                                  },
                                  {
                                    latitude: 12.93303072,
                                    longitude: 77.69582153,
                                  },
                                  {
                                    latitude: 12.93303082,
                                    longitude: 77.69582085,
                                  },
                                  {
                                    latitude: 12.93310593,
                                    longitude: 77.6958326,
                                  },
                                  {
                                    latitude: 12.93310365,
                                    longitude: 77.69584792,
                                  },
                                  {
                                    latitude: 12.93312705,
                                    longitude: 77.69585158,
                                  },
                                  {
                                    latitude: 12.93308926,
                                    longitude: 77.69610586,
                                  },
                                  {
                                    latitude: 12.93312955,
                                    longitude: 77.69611216,
                                  },
                                  {
                                    latitude: 12.93313049,
                                    longitude: 77.69611229,
                                  },
                                  {
                                    latitude: 12.93313103,
                                    longitude: 77.69610865,
                                  },
                                  {
                                    latitude: 12.93313281,
                                    longitude: 77.69610893,
                                  },
                                  {
                                    latitude: 12.93311854,
                                    longitude: 77.69620497,
                                  },
                                  {
                                    latitude: 12.93311675,
                                    longitude: 77.69620469,
                                  },
                                  {
                                    latitude: 12.93311757,
                                    longitude: 77.69619923,
                                  },
                                ],
                              },
                            ],
                            locationPath: [
                              "fd280e15-60ae-42c1-aaaa-360c226de323",
                              "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                              "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                              "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                              "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                              "0c22613b-03cd-4898-bb23-19c13765bbfa",
                            ],
                            hierarchyMapSources: ["RICH_MAP", "SPACES_2D_MAP"],
                            access: "Full",
                            reportAccess: true,
                            apCnt: 0,
                            cameraCnt: 0,
                            locationPathFull: [
                              "fd280e15-60ae-42c1-aaaa-360c226de323",
                              "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                              "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                              "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                              "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                              "0c22613b-03cd-4898-bb23-19c13765bbfa",
                            ],
                            accessCodeCnt: null,
                            portalCnt: null,
                            key: "0c22613b-03cd-4898-bb23-19c13765bbfa",
                            label: "Floor 7",
                          },
                        ],
                        childData: [
                          {
                            id: "0c22613b-03cd-4898-bb23-19c13765bbfa",
                            name: "Floor 7",
                          },
                        ],
                        isChildrenLoading: true,
                        nodesBelow: 2,
                        parentTimeZoneId: "Africa/Abidjan",
                        inferredTimeZoneId: "Asia/Calcutta",
                        networkId: "7ae304c1-2818-40e4-8128-18fbbdf66749",
                        richMapInfo: {
                          richMapStatus: "PUBLISHED",
                          pointrJobId: "1690970980001",
                          version: "1",
                        },
                        address:
                          "CISCO BGL 17, Village, Kaverappa Layout, Kadubeesanahalli, Bengaluru, Karnataka, India",
                        zipcode: "560087",
                        totalArea: 600,
                        totalAreaUnit: "",
                        totalCapacity: 2000,
                        brandName: "Cisco",
                        geoLocation: "12.932471515981256,77.6959952373853",
                        locationPath: [
                          "fd280e15-60ae-42c1-aaaa-360c226de323",
                          "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                          "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                          "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                          "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                        ],
                        hierarchyMapSources: ["RICH_MAP", "SPACES_2D_MAP"],
                        access: "Full",
                        reportAccess: true,
                        apCnt: 0,
                        cameraCnt: 0,
                        locationPathFull: [
                          "fd280e15-60ae-42c1-aaaa-360c226de323",
                          "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                          "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                          "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                          "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                        ],
                        accessCodeCnt: null,
                        portalCnt: null,
                        key: "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                        label: "BGL 17",
                      },
                    ],
                    childData: [
                      {
                        id: "d34faf7b-17ca-4e0e-88a9-8a31989a6af2",
                        name: "BGL 17",
                      },
                    ],
                    isChildrenLoading: true,
                    nodesBelow: 3,
                    parentTimeZoneId: "Africa/Abidjan",
                    childTimeZoneId: "Asia/Calcutta",
                    inferredTimeZoneId: "",
                    totalArea: 0,
                    totalAreaUnit: "",
                    totalCapacity: 0,
                    geoLocation: "0.0,0.0",
                    locationPath: [
                      "fd280e15-60ae-42c1-aaaa-360c226de323",
                      "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                      "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                      "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                    ],
                    hierarchyMapSources: ["RICH_MAP", "SPACES_2D_MAP"],
                    access: "Full",
                    reportAccess: true,
                    apCnt: 0,
                    cameraCnt: 0,
                    locationPathFull: [
                      "fd280e15-60ae-42c1-aaaa-360c226de323",
                      "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                      "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                      "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                    ],
                    accessCodeCnt: null,
                    portalCnt: null,
                    key: "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                    label: "Test_Group",
                  },
                ],
                childData: [
                  {
                    id: "c71889b9-2871-4eb3-afac-ab8b4702d56b",
                    name: "Test_Group",
                  },
                ],
                isChildrenLoading: true,
                nodesBelow: 4,
                parentTimeZoneId: "Africa/Abidjan",
                inferredTimeZoneId: "",
                totalArea: 0,
                totalAreaUnit: "",
                totalCapacity: 0,
                geoLocation: "0.0,0.0",
                locationPath: [
                  "fd280e15-60ae-42c1-aaaa-360c226de323",
                  "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                  "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                ],
                hierarchyMapSources: ["RICH_MAP", "SPACES_2D_MAP"],
                access: "Full",
                reportAccess: true,
                apCnt: 0,
                cameraCnt: 0,
                locationPathFull: [
                  "fd280e15-60ae-42c1-aaaa-360c226de323",
                  "bc6f2b89-d7ca-4acb-922b-b58092522a45",
                  "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                ],
                accessCodeCnt: null,
                portalCnt: null,
                key: "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                label: "ABC",
              },
            ],
            childData: [
              {
                id: "32aa1f2b-65fa-45c8-b5dc-5a2752f2d707",
                name: "ABC",
              },
            ],
            isChildrenLoading: true,
            nodesBelow: 5,
            parentTimeZoneId: "Africa/Abidjan",
            inferredTimeZoneId: "Africa/Abidjan",
            networkId: "fa126b23-d817-4d52-ba71-e7019c4eac59",
            city: "Bangalore",
            state: "Karnataka",
            country: "India",
            address:
              "Madiwala, 1st Stage, BTM Layout, Bengaluru, Karnataka, India",
            zipcode: "560103",
            totalArea: 100,
            totalAreaUnit: "",
            totalCapacity: 100,
            brandName: "BANGLORE",
            geoLocation: "12.93279094333589,77.69599000879211",
            licenseInfo: {
              id: "f29a0dc5-04f0-4f4b-93b7-9fad749baf0c",
              licenseTypes: ["SMART_VENUES"],
            },
            locationPath: [
              "fd280e15-60ae-42c1-aaaa-360c226de323",
              "bc6f2b89-d7ca-4acb-922b-b58092522a45",
            ],
            hierarchyMapSources: ["RICH_MAP", "SPACES_2D_MAP"],
            access: "Full",
            reportAccess: true,
            apCnt: 0,
            cameraCnt: 0,
            locationPathFull: [
              "fd280e15-60ae-42c1-aaaa-360c226de323",
              "bc6f2b89-d7ca-4acb-922b-b58092522a45",
            ],
            accessCodeCnt: null,
            portalCnt: null,
            key: "bc6f2b89-d7ca-4acb-922b-b58092522a45",
            label: "BANGLORE",
          },
        ],
        childData: [
          {
            id: "bc6f2b89-d7ca-4acb-922b-b58092522a45",
            name: "BANGLORE",
          },
        ],
        isChildrenLoading: true,
        nodesBelow: 5,
        inferredTimeZoneId: "Africa/Abidjan",
        country: "Afghanistan",
        totalArea: 111,
        totalAreaUnit: "",
        totalCapacity: 101,
        brandName: "Ivan Root",
        geoLocation: "0.0,0.0",
        licenseInfo: {
          id: "14eca84a-5346-4197-a84b-cc7341de8267",
          licenseTypes: ["EXTEND"],
        },
        locationPath: ["fd280e15-60ae-42c1-aaaa-360c226de323"],
        hierarchyMapSources: [
          "RICH_MAP",
          "SPACES_2D_MAP",
          "MERAKI",
          "DNAC",
          "PRIME",
          "CMX",
        ],
        lastUpdateTimestamp: 1702356187289,
        access: "Read",
        reportAccess: false,
        apCnt: 0,
        cameraCnt: 0,
        locationPathFull: ["fd280e15-60ae-42c1-aaaa-360c226de323"],
        accessCodeCnt: null,
        portalCnt: null,
        key: "fd280e15-60ae-42c1-aaaa-360c226de323",
        label: "21Feb25ACT Root",
      },
    ];
  },

  getDummyTreeNodesData() {
    return [
      {
        id: 1,
        key: 1,
        name: "Locations",
        label: "Locations",
        type: ["ROOT"],
        parent: -1,
        path: [1],
        locationBit: 786437,
        myCountJson: {
          ap: 0,
          ble: 0,
          rule: 0,
          net: 0,
          user: 0,
          ac: 0,
        },
        children: [
          {
            id: 2,
            key: 2,
            name: "San Francisco",
            label: "San Francisco",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 2],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 3,
            key: 3,
            name: "New York",
            label: "New York",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 3],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 4,
            key: 4,
            name: "London",
            label: "London",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 4],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 5,
            key: 5,
            name: "Dubai",
            label: "Dubai",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 5],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 6,
            key: 6,
            name: "Bangalore",
            label: "Bangalore",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 6],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 7,
            key: 7,
            name: "Frankfurt",
            label: "Frankfurt",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 7],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 9,
            key: 9,
            name: "Cape Town",
            label: "Cape Town",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 9],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 10,
            key: 10,
            name: "Amsterdam",
            label: "Amsterdam",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 10],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
          {
            id: 11,
            key: 11,
            name: "Sydney",
            label: "Sydney",
            type: ["NETWORK"],
            parent: 1,
            path: [1, 11],
            locationBit: 811013,
            myCountJson: {
              ap: 0,
              ble: 0,
              rule: 0,
              net: 0,
              user: 0,
              ac: 0,
            },
            accessCodeClickable: false,
            userClickable: false,
            networkClickable: false,
            proximityClickable: false,
            bleBeaconClickable: false,
            accessPointClickable: false,
            canDelete: true,
          },
        ],
        expanded: true,
        canDelete: true,
      },
    ];
  },

  getTreeTableNodesData() {
    return [
      {
        key: "0",
        data: {
          name: "Applications",
          size: "100kb",
          type: "Folder",
        },
        children: [
          {
            key: "0-0",
            data: {
              name: "React",
              size: "25kb",
              type: "Folder",
            },
            children: [
              {
                key: "0-0-0",
                data: {
                  name: "react.app",
                  size: "10kb",
                  type: "Application",
                },
              },
              {
                key: "0-0-1",
                data: {
                  name: "native.app",
                  size: "10kb",
                  type: "Application",
                },
              },
              {
                key: "0-0-2",
                data: {
                  name: "mobile.app",
                  size: "5kb",
                  type: "Application",
                },
              },
            ],
          },
          {
            key: "0-1",
            data: {
              name: "editor.app",
              size: "25kb",
              type: "Application",
            },
          },
          {
            key: "0-2",
            data: {
              name: "settings.app",
              size: "50kb",
              type: "Application",
            },
          },
        ],
      },
      {
        key: "1",
        data: {
          name: "Cloud",
          size: "20kb",
          type: "Folder",
        },
        children: [
          {
            key: "1-0",
            data: {
              name: "backup-1.zip",
              size: "10kb",
              type: "Zip",
            },
          },
          {
            key: "1-1",
            data: {
              name: "backup-2.zip",
              size: "10kb",
              type: "Zip",
            },
          },
        ],
      },
      {
        key: "2",
        data: {
          name: "Desktop",
          size: "150kb",
          type: "Folder",
        },
        children: [
          {
            key: "2-0",
            data: {
              name: "note-meeting.txt",
              size: "50kb",
              type: "Text",
            },
          },
          {
            key: "2-1",
            data: {
              name: "note-todo.txt",
              size: "100kb",
              type: "Text",
            },
          },
        ],
      },
      {
        key: "3",
        data: {
          name: "Documents",
          size: "75kb",
          type: "Folder",
        },
        children: [
          {
            key: "3-0",
            data: {
              name: "Work",
              size: "55kb",
              type: "Folder",
            },
            children: [
              {
                key: "3-0-0",
                data: {
                  name: "Expenses.doc",
                  size: "30kb",
                  type: "Document",
                },
              },
              {
                key: "3-0-1",
                data: {
                  name: "Resume.doc",
                  size: "25kb",
                  type: "Resume",
                },
              },
            ],
          },
          {
            key: "3-1",
            data: {
              name: "Home",
              size: "20kb",
              type: "Folder",
            },
            children: [
              {
                key: "3-1-0",
                data: {
                  name: "Invoices",
                  size: "20kb",
                  type: "Text",
                },
              },
            ],
          },
        ],
      },
      {
        key: "4",
        data: {
          name: "Downloads",
          size: "25kb",
          type: "Folder",
        },
        children: [
          {
            key: "4-0",
            data: {
              name: "Spanish",
              size: "10kb",
              type: "Folder",
            },
            children: [
              {
                key: "4-0-0",
                data: {
                  name: "tutorial-a1.txt",
                  size: "5kb",
                  type: "Text",
                },
              },
              {
                key: "4-0-1",
                data: {
                  name: "tutorial-a2.txt",
                  size: "5kb",
                  type: "Text",
                },
              },
            ],
          },
          {
            key: "4-1",
            data: {
              name: "Travel",
              size: "15kb",
              type: "Text",
            },
            children: [
              {
                key: "4-1-0",
                data: {
                  name: "Hotel.pdf",
                  size: "10kb",
                  type: "PDF",
                },
              },
              {
                key: "4-1-1",
                data: {
                  name: "Flight.pdf",
                  size: "5kb",
                  type: "PDF",
                },
              },
            ],
          },
        ],
      },
      {
        key: "5",
        data: {
          name: "Main",
          size: "50kb",
          type: "Folder",
        },
        children: [
          {
            key: "5-0",
            data: {
              name: "bin",
              size: "50kb",
              type: "Link",
            },
          },
          {
            key: "5-1",
            data: {
              name: "etc",
              size: "100kb",
              type: "Link",
            },
          },
          {
            key: "5-2",
            data: {
              name: "var",
              size: "100kb",
              type: "Link",
            },
          },
        ],
      },
      {
        key: "6",
        data: {
          name: "Other",
          size: "5kb",
          type: "Folder",
        },
        children: [
          {
            key: "6-0",
            data: {
              name: "todo.txt",
              size: "3kb",
              type: "Text",
            },
          },
          {
            key: "6-1",
            data: {
              name: "logo.png",
              size: "2kb",
              type: "Picture",
            },
          },
        ],
      },
      {
        key: "7",
        data: {
          name: "Pictures",
          size: "150kb",
          type: "Folder",
        },
        children: [
          {
            key: "7-0",
            data: {
              name: "barcelona.jpg",
              size: "90kb",
              type: "Picture",
            },
          },
          {
            key: "7-1",
            data: {
              name: "primeng.png",
              size: "30kb",
              type: "Picture",
            },
          },
          {
            key: "7-2",
            data: {
              name: "prime.jpg",
              size: "30kb",
              type: "Picture",
            },
          },
        ],
      },
      {
        key: "8",
        data: {
          name: "Videos",
          size: "1500kb",
          type: "Folder",
        },
        children: [
          {
            key: "8-0",
            data: {
              name: "primefaces.mkv",
              size: "1000kb",
              type: "Video",
            },
          },
          {
            key: "8-1",
            data: {
              name: "intro.avi",
              size: "500kb",
              type: "Video",
            },
          },
        ],
      },
    ];
  },

  getTreeTableNodes() {
    return Promise.resolve(this.getTreeTableNodesData());
  },

  getTreeNodes() {
    return Promise.resolve(this.getTreeNodesData());
  },

  getDummyTreeNodes() {
    return Promise.resolve(this.getDummyTreeNodesData());
  },
};
